module.exports = __webpack_public_path__ + "static/media/auto.18ebbf78.svg";